import type { WorldcupResearchCoverageQuery } from '@ballpeek/api/client'
import { queryOptions } from '@tanstack/react-query'
import { listDataQualityArchives, listDataQualityCoverage } from './api'

export const adminDataQualityQueryKeys = {
  all: ['admin-data-quality'] as const,
  coverage: (query: Partial<WorldcupResearchCoverageQuery> = {}) => [...adminDataQualityQueryKeys.all, 'coverage', query] as const,
  archives: () => [...adminDataQualityQueryKeys.all, 'archives'] as const,
}

export function adminDataQualityCoverageQueryOptions(query: Partial<WorldcupResearchCoverageQuery> = {}) {
  return queryOptions({
    queryKey: adminDataQualityQueryKeys.coverage(query),
    queryFn: () => listDataQualityCoverage(query),
  })
}

export function adminDataQualityArchivesQueryOptions() {
  return queryOptions({
    queryKey: adminDataQualityQueryKeys.archives(),
    queryFn: listDataQualityArchives,
  })
}
